import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Tabs, Tab, Button } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory from 'react-bootstrap-table2-paginator'

const columns = [
	{
		dataField: 'id',
		text: 'ID',
		sort: true,
		title: true,
		hidden: true
	},
	{
		dataField: 'dateOfCreation',
		text: 'Date of creation',
		sort: true,
		title: true
	},
	{
		dataField: 'dateOfCompletion',
		text: 'Date of completion',
		sort: true,
		title: true
	},
	{
		dataField: 'amountToSelf',
		text: 'Allocation to self',
		sort: true,
		title: true
	},
	{
		dataField: 'amountToOther',
		text: 'Allocation to the other',
		sort: true,
		title: true
	},
	{
		dataField: 'allocationBy',
		text: 'Allocation by',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorGender',
		text: 'Gender',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorAge',
		text: 'Age',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorCity',
		text: 'City',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorState',
		text: 'State',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorIsMarried',
		text: 'Married',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorHasChildren',
		text: 'Children',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorEthnicity',
		text: 'Ethnicity',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorReligion',
		text: 'Religion',
		sort: true,
		title: true
	},
	{
		dataField: 'creatorPoliticalAffiliations',
		text: 'Politicial Affiliation',
		sort: true,
		title: true
	},
	{
		dataField: 'allocationTo',
		text: 'Allocation by',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverGender',
		text: 'Gender',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverAge',
		text: 'Age',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverCity',
		text: 'City',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverState',
		text: 'State',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverIsMarried',
		text: 'Married',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverHasChildren',
		text: 'Children',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverEthnicity',
		text: 'Ethnicity',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverReligion',
		text: 'Religion',
		sort: true,
		title: true
	},
	{
		dataField: 'receiverPoliticalAffiliations',
		text: 'Politicial Affiliation',
		sort: true,
		title: true
	}
]

class View extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			selected: [],
			showBtn: false
		}
	}

	toggleBtn () {
		this.setState({ showBtn: !this.state.showBtn })

	}

	indication () {
		return <div className='text-center'>No data</div>
	}

	render () {
		const { all, real, lucky, markAsLucky, isBtnDisabled } = this.props
		const { selected, showBtn } = this.state

		const selectRow = {
			mode: 'checkbox',
			clickToSelect: true,
			style: { backgroundColor: '#c8e6c9' },
			selected,
			onSelect: (row, isSelect) => {
				if (isSelect) {
					this.setState((prevState) => {
						return { selected: [...prevState.selected, row.id] }
					})
				}
				else {
					this.setState(() => {
						return { selected: selected.filter(x => x !== row.id) }
					})
				}

			}
		}

		const rowStyle = row => {
			const style = {}
			if (row.status === 'INCOMPLETE') {
				style.backgroundColor = '#f9f9f9'
			}

			if (row.status === 'COMPLETE') {
				style.backgroundColor = '#fff'
			}

			return style
		}

		const paginationOptions = {
			paginationSize: 3,
			pageStartIndex: 1,
			withFirstAndLast: true,
			hidePageListOnlyOnePage: true,
			showTotal: true,
			sizePerPageList: [{
				text: '50', value: 50
			}]
		}

		return <div className='mb'>
			<Grid fluid>
				<Row className='show-grid'>
					<Col xs={12}>
						<Tabs id='tab-container'>
							<Tab eventKey={1} title='All allocations'>
								<BootstrapTable
									classes='table--scroll-x mt'
									keyField='id'
									data={all}
									columns={columns}
									striped
									noDataIndication={this.indication}
									pagination={ paginationFactory(paginationOptions) }
									rowStyle={ rowStyle }
								/>
							</Tab>
							<Tab eventKey={2} title='Allocations carried out for real'>
								<BootstrapTable
									classes='table--scroll-x mt'
									keyField='id'
									data={real}
									columns={columns}
									striped
									noDataIndication={this.indication}
									pagination={ paginationFactory(paginationOptions) }
									rowStyle={ rowStyle }
								/>
							</Tab>
							<Tab eventKey={3} title='Mark the daily "lucky" allocations'>
								<p className='mt'>
                                    Every day between 8:00 PM PT and 9:00 PM PT the button bellow will be enabled  and you will be able to pick a couple of random allocations,
                                    which will be carried out for real.
								</p>
								<p>
                                    Aletrnatively, at 9:00 PM PT, if you haven't choosen the "lucky" daily allocations,
                                    the system will pick 2 random allocations.
								</p>
								<Row className="show-grid">
									<Col xs={6}>
										<Button
											onClick={() => markAsLucky(selected)}
											type="submit"
											bsStyle="primary"
											disabled={isBtnDisabled}
											title={isBtnDisabled ? 'The button will be enabled between 8:00 PM PT and 9:00 PM PT.' : ''}
										>Pick the 2 selected allocations</Button>
									</Col>
									<Col xs={6}>
										<div className='text-right'>
											<Button onDoubleClick={() => this.toggleBtn()} bsStyle="link">{showBtn ? 'Double click to hide button' : 'Double click to show button'}</Button>
											{
												showBtn &&
                                                <Button
                                                	onClick={() => markAsLucky(selected)}
                                                	type="submit"
                                                	bsStyle="warning"
                                                	disabled={!selected.length}
                                                	title={!selected.length ? 'Please pick at least one allocation.' : ''}
                                                >Pick in case you missed</Button>
											}
										</div>
									</Col>
								</Row>
								<BootstrapTable
									classes='table--scroll-x mt'
									keyField='id'
									data={lucky}
									columns={columns}
									striped
									noDataIndication={this.indication}
									pagination={ paginationFactory(paginationOptions) }
									selectRow={ selectRow }
									rowStyle={ rowStyle }
								/>
							</Tab>
						</Tabs>
					</Col>
				</Row>
			</Grid>
		</div>
	}
}

View.propTypes = {
	all: PropTypes.array,
	real: PropTypes.array,
	lucky: PropTypes.array,
	markAsLucky: PropTypes.func,
	isBtnDisabled: PropTypes.bool
}

export default View


// WEBPACK FOOTER //
// ./src/routes/Allocations/components/View.js